import TestimonialCard from "./TestimonialCard";

/**
 * Shared Elemsee testimonial component used across onboarding flow.
 * Contains the specific testimonial quote to avoid duplication.
 */
const ElemseeTestimonial = ({ className }: { className?: string }) => {
  return (
    <TestimonialCard
      quote="It's so easy to use with so many great, accessible recipes. I use it all the time, and recommend it to friends!"
      author="Elemsee"
      className={className}
    />
  );
};

export default ElemseeTestimonial;
